<template>
  <div class="payment-success-page">
    <div>
      <img src="@/assets/img/completed.png" alt="" />
      <p class="payment-success-message">
        Thanh toán thành công!!!<br />
        Hợp đồng {{contractNo}} đã thanh toán thành công số tiền {{Number(amount).toLocaleString()}}.
      </p>
      <div class="block md:flex justify-center">
        <router-link class="primary-button" :to="{ name: 'loanSummary' }" >
          Về trang chủ
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PaymentSuccess',
  data () {
    return {
    }
  },
  computed: {
    contractNo () {
      return this.$route.query.contractNo
    },
    amount () {
      return this.$route.query.amount
    }
  },
  methods: {
  }
}
</script>
